module.exports = __webpack_public_path__ + "img/contactUS.96d64862.svg";